import { useContext } from 'react';

import { Auth, FwAuthContext } from './FwAuthContext';

const useFwAuth = () => useContext<Auth>(FwAuthContext);

export { useFwAuth };
